import { getSelectedTableView, listViewStore, } from 'owa-mail-list-store';
export function getSelectedGroupId() {
    var tableView = getSelectedTableView();
    return getGroupId(tableView);
}
export function getGroupId(tableView) {
    return tableView && tableView.tableQuery.type == 2 /* Group */
        ? tableView.tableQuery.folderId
        : null;
}
export function getGroupIdFromTableViewId(tableViewId) {
    var tableView = listViewStore.tableViews.get(tableViewId);
    return getGroupId(tableView);
}
//# sourceMappingURL=getGroupId.js.map